export default __webpack_public_path__ + "static/4-4a6300dffff48f5dabd3a27b772d72eb.woff";